import { ChangeEvent } from 'react';
import { ICustomSurveyMatrixRow } from './ICustomSurveyMatrixRow';

export const validQuestionTypes = [
  'CUSTOMSINGLE',
  'CUSTOMMULTIPLE',
  'CUSTOMGATE',
  'CUSTOMTEXT',
  'CUSTOMYESNO',
  'CUSTOMDROPDOWN',
  'CUSTOMSCALENPS',
  'CUSTOMFEEDBACK',
  'CUSTOMMATRIX',
] as const;

export type QuestionTypes = (typeof validQuestionTypes)[number];

export const isQuestionType = (type: string): type is QuestionTypes => {
  return (validQuestionTypes as readonly string[]).includes(type);
};

export interface ISurvey {
  archived: boolean;
  archivedAt: string;
  averageRating: number;
  companyLogo: string;
  companyName: string;
  companyWebsiteUrl: string;
  contactEmail: string;
  contactForm: boolean;
  createdAt: string;
  customFont: string;
  customFontFormat: string;
  customCss?: string;
  error?: {
    code: number;
    message: string;
  };
  id: string;
  imprintLink: string;
  logoLink: string;
  label: string;
  lang: string;
  note: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  platform: string;
  platformUrl: string;
  platformName: string;
  primaryColor: string;
  privacyPolicyLink: string;
  question: string;
  questionEditable: boolean;
  score: number;
  secondaryColor: string;
  totalCount: number;
  type: string;
  title?: string;
  titleNegative?: string;
  updatedAt: string;
  feedbackActive?: boolean;
  feedbackText?: string;
  feedbackTitle?: string;
  introText?: string;
  introTextNegative?: string;
  introDisabled?: boolean;
  outroText?: string;
  outroTextNegative?: string;
  outroDisabled?: boolean;
  negativeText?: string;
  positiveText?: string;
  neutralText?: string;
  slug?: string;
  toggleArchive?: (id: string) => void;
  scale?: {
    highText: string;
    lowText: string;
  };
  questions?: {
    questionId: string;
    question: string;
    score: number;
    feedback: string;
    options?: any;
    rows?: ICustomSurveyMatrixRow[];
    optional?: boolean;
    allowCustom: boolean;
    type?: QuestionTypes;
    questionI18n: Record<string, string>;
  }[];
  answers?: [
    {
      answerOne: string;
      answerTwo: string;
      answerThree: string;
      answerFour: string;
      answerFive: string;
    }
  ];
  progressBar?: boolean;
}
